import React, { useState } from "react";
import { api, apiError } from "../lib/api";

const EXPORTS = [
  { key: "organisations", label: "Organisations" },
  { key: "contacts", label: "Contacts" },
  { key: "contrats", label: "Contrats" },
  { key: "kpax", label: "KPAX" },
  { key: "devis", label: "Devis" },
  { key: "bons-commande", label: "Bons de commande" },
];

export default function ExportPage() {
  const [busy, setBusy] = useState<string | null>(null);

  const download = async (key: string) => {
    setBusy(key);
    try {
      const url = key === "global" ? "/export/global" : `/export/${key}`;
      const res = await api.get(url, { responseType: "blob" });
      const objectUrl = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = key === "global" ? "naxium_export_global.zip" : `${key}.csv`;
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (e) {
      alert(apiError(e));
    } finally {
      setBusy(null);
    }
  };

  return (
    <div data-testid="export-page" className="max-w-3xl space-y-4">
      <h1 className="text-2xl font-extrabold text-green">Export CSV</h1>
      <p className="text-sm text-muted">
        Fichiers CSV avec séparateur « ; » et BOM UTF-8, compatibles Excel (accents préservés).
      </p>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
        {EXPORTS.map((x) => (
          <button
            key={x.key}
            data-testid={`export-btn-${x.key}`}
            className="nx-card flex flex-col items-start gap-1 p-4 text-left transition-transform hover:-translate-y-0.5"
            disabled={busy !== null}
            onClick={() => download(x.key)}
          >
            <span className="text-sm font-bold text-green">{x.label}</span>
            <span className="text-xs text-muted">{busy === x.key ? "Téléchargement…" : "Exporter en CSV"}</span>
          </button>
        ))}
        <button
          data-testid="export-btn-global"
          className="nx-card flex flex-col items-start gap-1 border-lime bg-lime-soft p-4 text-left transition-transform hover:-translate-y-0.5"
          disabled={busy !== null}
          onClick={() => download("global")}
        >
          <span className="text-sm font-extrabold text-green">Export global</span>
          <span className="text-xs text-muted">{busy === "global" ? "Téléchargement…" : "Archive ZIP de tous les CSV"}</span>
        </button>
      </div>
    </div>
  );
}
